import "./Thumbnail.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import FileIcon from "~/content/icons/file.svg?react";

export function Thumbnail({ className, fileName, onClick }) {
  // Limit file extension to 4 chars to fit default file icon
  const extension = fileName.split(".").pop().substring(0, 4);

  return (
    <button
      className={classNames({
        thumbnail: true,
        [className]: !!className,
      })}
      aria-label={fileName}
      onClick={onClick}
      type="button"
    >
      <FileIcon />
      {extension && <div className="thumbnail__extension">{extension}</div>}
    </button>
  );
}

Thumbnail.propTypes = {
  className: PropTypes.string,
  fileName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
